"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const lodash_1 = require("lodash");
const ChoiceItemsContainer_1 = __importDefault(require("./ChoiceItemsContainer"));
const CustomMapperButton_1 = __importDefault(require("./CustomMapperButton"));
const CustomMapperStyles_1 = __importDefault(require("./CustomMapperStyles"));
const TOP_OPTION_COUNT = 3;
const ChoiceGroupBody = ({ items, onShowAllOptions, onSelect, }) => (common_utils_1.isolateComponent("div", { css: CustomMapperStyles_1.default.root },
    common_utils_1.isolateComponent(ChoiceItemsContainer_1.default, { items: lodash_1.take(items, TOP_OPTION_COUNT), onSelect: onSelect }),
    items.length > TOP_OPTION_COUNT && (common_utils_1.isolateComponent(CustomMapperButton_1.default, { color: "customBlue", onClick: onShowAllOptions }, "Show all options"))));
exports.default = ChoiceGroupBody;
